import React from 'react';

import './PasswordStrength.scss';

enum FRAGMENT_STATUS {
	DISABLED = 'disabled',
	ENABLED = 'enabled'
}

export const PASSWORD_REG_EXP = {
	latter: /^(?=(.*[a-z])).*$/,
	uppercase: /^(?=(.*[A-Z])).*$/,
	number: /^(?=(.*[0-9])).*$/,
	symbol: /^(?=(.*[!?@#$%^&*()\-_+.])).*$/,
	complete: /^(?=(\S*[a-z])+)(?=(\S*[A-Z])+)(?=(\S*[0-9])+)(?=(\S*[!?@#$%^&*()\-_+.])+)\S+$/
};

interface IPasswordStrength {
	password: string;
}

export const PasswordStrength = ({ password }: IPasswordStrength): JSX.Element => {
	const firstCon = Number(PASSWORD_REG_EXP.latter.test(password));
	const secondCon = Number(PASSWORD_REG_EXP.uppercase.test(password));
	const thirdCon = Number(PASSWORD_REG_EXP.number.test(password));
	const fourthCon = Number(PASSWORD_REG_EXP.symbol.test(password));
	const fifthCon = Number(password.length >= 8 && password.length <= 50 && PASSWORD_REG_EXP.complete.test(password));

	const conSummary = firstCon + secondCon + thirdCon + fourthCon + fifthCon;

	const fragments = [
		{
			status: conSummary >= 1 ? FRAGMENT_STATUS.ENABLED : FRAGMENT_STATUS.DISABLED
		},
		{
			status: conSummary >= 2 ? FRAGMENT_STATUS.ENABLED : FRAGMENT_STATUS.DISABLED
		},
		{
			status: conSummary >= 3 ? FRAGMENT_STATUS.ENABLED : FRAGMENT_STATUS.DISABLED
		},
		{
			status: conSummary >= 4 ? FRAGMENT_STATUS.ENABLED : FRAGMENT_STATUS.DISABLED
		},
		{
			status: conSummary === 5 ? FRAGMENT_STATUS.ENABLED : FRAGMENT_STATUS.DISABLED
		}
	];

	return (
		<div className="fragments-container">
			{
				fragments?.map((fragment, index) => (
					<div key={`${fragment}-${index}`} className={`fragment fragment-${fragment.status}`} />
				))
			}
		</div>
	);
};
